import { Outlet } from 'react-router-dom';
import Menu from '../Menu';
import './background.css';
import { useUser } from '../../UserContext';
import { useUI } from '../../UIContext';
import { useEffect, useState } from 'react';

function Background() {
    const { user } = useUser();
    const { backgroundImg } = useUI();

    const [background, setBackground] = useState(undefined);

    useEffect(() => {
        if (!backgroundImg) {
            setBackground(undefined);
            return;
        }

        const blobUrl = URL.createObjectURL(backgroundImg);
        setBackground(blobUrl);

        return () => {
            URL.revokeObjectURL(blobUrl);
        };
    }, [backgroundImg]);

    if (!user)
        return;

    return (
        <>
            <div className="app background" style={{
                backgroundImage: background ? `url(${background})` : undefined,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            }}>
                <main>
                    <div className='container glass-effect-35'>
                        <div className='container-menu'>
                            <Menu />
                        </div>

                        <div className='container-content'>
                            <Outlet />
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
}

export default Background;